import axios from 'axios';
import {
  MONDAY_CONNECT_SUCCESS,
  MONDAY_CONNECT_FAIL,
  MONDAY_LOADING,
  MONDAY_RESET
} from './types';

// Helper to call Monday.com GraphQL via our backend proxy
export const mondayGql = (query, variables, apiKeyOverride) => async (dispatch, getState) => {
  const token = getState().auth.token;
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': token
  };
  if (apiKeyOverride) {
    headers['x-monday-token'] = apiKeyOverride;
  }

  const res = await axios.post('/api/monday/graphql', { query, variables }, { headers });

  if (res.data.errors && res.data.errors.length) {
    const msgs = res.data.errors.map(e => e.message).join('; ');
    throw new Error(msgs);
  }
  return res.data.data;
};

// Connect to a Monday.com board
export const connectBoard = (boardId, apiKeyOverride) => async (dispatch) => {
  dispatch({ type: MONDAY_LOADING });
  try {
    const query = `
      query($bid:[ID!]!) {
        boards(ids:$bid) {
          id name
          groups { id title }
          columns { id title type }
          items_page(limit:5) {
            items {
              subitems { board { columns { id title type } } }
            }
          }
        }
      }`;
    const data = await dispatch(mondayGql(query, { bid: [boardId] }, apiKeyOverride));

    if (!data.boards || !data.boards.length) {
      throw new Error('Board not found. Check ID and API key permissions.');
    }

    const board = data.boards[0];
    const SKIP = ['name', 'subtasks', 'button', 'formula', 'auto_number', 'creation_log', 'last_updated', 'color_picker'];
    const itemCols = board.columns.filter(c => !SKIP.includes(c.type));

    let subCols = [];
    const items = board.items_page && board.items_page.items;
    if (items) {
      for (const it of items) {
        if (it.subitems && it.subitems.length && it.subitems[0].board) {
          subCols = it.subitems[0].board.columns.filter(c => !SKIP.includes(c.type));
          break;
        }
      }
    }

    dispatch({
      type: MONDAY_CONNECT_SUCCESS,
      payload: {
        boardId: board.id,
        boardName: board.name,
        groups: board.groups,
        itemCols,
        subCols
      }
    });

    return board;
  } catch (err) {
    dispatch({ type: MONDAY_CONNECT_FAIL, payload: err.message });
    throw err;
  }
};

export const resetMonday = () => ({ type: MONDAY_RESET });
